import React from 'react'
import { Text, View } from 'react-native'
import { tv } from 'tailwind-variants'

import type { CoverageBenefit } from '@flows/index'
import { body2 } from '@ui-kit/core/typography'

import { CoverageCmsIcon } from './CoverageCmsIcon'

const styles = tv({
  slots: {
    container: 'w-full flex-col gap-4 rounded-xl bg-grey-100 p-6 md:flex-row',
    item: 'flex-1 flex-row gap-2',
    icon: 'h-6 w-6 shrink-0',
    content: 'flex-1 flex-col',
    title: body2({ bold: true }),
    description: body2({ color: 'grey700' }),
  },
})

export const CoverageBenefits = ({ benefits }: { benefits: CoverageBenefit[] }) => {
  const { container, item, icon, content, title, description } = styles()

  if (benefits.length === 0) {
    return null
  }

  return (
    <View className={container()}>
      {benefits.map((benefit) => (
        <View key={benefit._key} className={item()}>
          <View className={icon()}>
            <CoverageCmsIcon icon={benefit.icon} />
          </View>
          <View className={content()}>
            <Text className={title()}>{benefit.title}</Text>
            <Text className={description()}>{benefit.subtitle}</Text>
          </View>
        </View>
      ))}
    </View>
  )
}
